import { Card, Image, Text, Group, Badge, Button, Stack } from '@mantine/core';
import { VoyageVibeResult, AttractionStateInput } from '@generated/graphql';
import classes from './attraction-card.module.css';
import InterestRating from './interest-rating';

const noImageUrl = '/no-image-placeholder.svg';

interface AttractionCardProps {
  attraction: VoyageVibeResult;
  updateAttractionInterest: (attractionId: string, interest: number) => void;
  interestState: AttractionStateInput;
}

function AttractionCard({ attraction, updateAttractionInterest, interestState }: AttractionCardProps) {
  const interestHandler = (interest: number) => {
    const currentValue = interestState?.interest ?? 0;
    const nextValue = interest === currentValue ? 0 : interest;
    updateAttractionInterest(attraction.id, nextValue);
  };

  return (
    <Card withBorder radius="md" p="md" className={classes.card} mb={20}>
      <Card.Section>
        <Image
          src={attraction.photoUrl}
          fallbackSrc={noImageUrl}
          alt={attraction.nameDisplay || 'Attraction'}
          height={200}
        />
      </Card.Section>

      <Card.Section className={classes.section} mt="md">
        <Stack>
          <Group justify="space-between">
            <Text fz="lg" fw={700}>
              {attraction.nameDisplay}
            </Text>
            <Badge size="sm" variant="light">
              Score: {attraction.scoreActAttr}
            </Badge>
          </Group>
          {attraction.nameDisplay !== attraction.nameLocal && <Text pt={0}>{attraction.nameLocal}</Text>}
          <Text fz="md" fw={500}>
            {attraction.formattedAddress}
          </Text>
        </Stack>
        <Text fz="sm" mt="xs">
          {attraction.editorialSummary}
        </Text>
      </Card.Section>

      <Group mt="xs">
        <Button
          component="a"
          href={attraction.googleMapsUri ?? undefined}
          target="_blank"
          rel="noopener noreferrer"
          radius="md"
          style={{ flex: 1 }}
          p={5}
          disabled={!attraction.googleMapsUri}
        >
          Details
        </Button>
        <Stack gap={0} align="center">
          <Text>Your Interest</Text>
          <InterestRating value={interestState?.interest ?? 0} onChange={interestHandler} />
        </Stack>
      </Group>
    </Card>
  );
}

export default AttractionCard;
